// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2m4cc","list":"styles_list__2i8TO"};